// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PricingComponent_main__ZvYzs {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border: 2px solid white;
  border-radius: 25px;
  margin: 1rem;
  padding: 1.5rem;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1); 

  @media (max-width: 720px) {
    padding-left: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }
}

.PricingComponent_first__5atGc {
  align-items: center;
  text-align: center;
  align-content: center;
  margin-bottom: 1rem;


  @media (min-width: 1020px) {
   margin-bottom: 0px;
  }
}

.PricingComponent_verticalline__I9GLG {
  width: 1px;
  height: 70px;
  background-color: gray;
  margin: 0 20px;
  @media (max-width: 720px) {
    background-color: white;
    height: 10px;
    width: 1px;
  }
}

.PricingComponent_second__YoukZ {
  text-align: center;
}

.PricingComponent_third__dP8Fu {
  align-items: center;
  display: flex;
  flex-direction: column;
}



.PricingComponent_user__k7Hnp {
  display: flex;
  align-items: center;
}

.PricingComponent_inputContainer__xZnMQ {
  flex: 1 1;
  margin-right: 1rem; 
}

.PricingComponent_inputRange__SH\\+R\\+ {
  /* border: 2px solid #477af6; */
  border-radius: 10px;
  width: 100%;
  height: 20px;
  appearance: none;
  background: linear-gradient(to right, #477af6 0%, #477af6 var(--fillPercentage, 0%), #ddd var(--fillPercentage, 0%), #ddd 100%);
  outline: none;
  cursor: pointer;
}

.PricingComponent_inputRange__SH\\+R\\+::-webkit-slider-thumb {
  appearance: none;
  width: 30px;
  height: 30px;
  background: #477af6;
  border-radius: 50%;
  cursor: pointer;
}

.PricingComponent_inputRange__SH\\+R\\+::-moz-range-thumb {
  width: 30px;
  height: 30px;
  background: #477af6;
  border-radius: 50%;
  cursor: pointer;
}

.PricingComponent_valueText__PHSff {
  text-align: center;
}
















.PricingComponent_user__k7Hnp {
  display: flex;
  margin-top: 0.5rem;
  
  /* flex-direction: column-reverse;
  justify-content: space-between; */
  align-items: center;
  @media (max-width:400px) {
    flex-direction: column;
    
  }
}

.PricingComponent_one__BmtVX,
.PricingComponent_two__6nwz7,
.PricingComponent_three__VacYM {
  border: 1px solid gray;
  margin: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: pointer; /* Add cursor pointer */
}

.PricingComponent_one__BmtVX.PricingComponent_selected__A5wGu,
.PricingComponent_two__6nwz7.PricingComponent_selected__A5wGu,
.PricingComponent_three__VacYM.PricingComponent_selected__A5wGu {
  border: 2px solid #3498db; /* Dark border for selected */
  background-color: #f0f0f0; /* Optional: Add background color for selected */
}


l {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 8px;
}

span {
  margin-left: 4px;
}

/* button {
  background-color: #3498db;
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 16px;
} */

.PricingComponent_info-popup__mTaF2 {
  position: absolute;
  right: 100%; 
  top: 0;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.PricingComponent_info-popup__mTaF2:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -5px; 
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent white;
}

.PricingComponent_class__PBxqE {
  margin: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/PricingComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0CAA0C;;EAE1C;IACE,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;;;EAGnB;GACC,kBAAkB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd;IACE,uBAAuB;IACvB,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+HAA+H;EAC/H,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;;;;;;;;;;;;;;;;AAiBA;EACE,aAAa;EACb,kBAAkB;;EAElB;mCACiC;EACjC,mBAAmB;EACnB;IACE,sBAAsB;;EAExB;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAE,uBAAuB;AAC1C;;AAEA;;;EAGE,yBAAyB,EAAE,6BAA6B;EACxD,yBAAyB,EAAE,gDAAgD;AAC7E;;;AAGA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".main {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  border: 2px solid white;\n  border-radius: 25px;\n  margin: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.1); \n\n  @media (max-width: 720px) {\n    padding-left: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n  }\n}\n\n.first {\n  align-items: center;\n  text-align: center;\n  align-content: center;\n  margin-bottom: 1rem;\n\n\n  @media (min-width: 1020px) {\n   margin-bottom: 0px;\n  }\n}\n\n.verticalline {\n  width: 1px;\n  height: 70px;\n  background-color: gray;\n  margin: 0 20px;\n  @media (max-width: 720px) {\n    background-color: white;\n    height: 10px;\n    width: 1px;\n  }\n}\n\n.second {\n  text-align: center;\n}\n\n.third {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n.user {\n  display: flex;\n  align-items: center;\n}\n\n.inputContainer {\n  flex: 1;\n  margin-right: 1rem; \n}\n\n.inputRange {\n  /* border: 2px solid #477af6; */\n  border-radius: 10px;\n  width: 100%;\n  height: 20px;\n  appearance: none;\n  background: linear-gradient(to right, #477af6 0%, #477af6 var(--fillPercentage, 0%), #ddd var(--fillPercentage, 0%), #ddd 100%);\n  outline: none;\n  cursor: pointer;\n}\n\n.inputRange::-webkit-slider-thumb {\n  appearance: none;\n  width: 30px;\n  height: 30px;\n  background: #477af6;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.inputRange::-moz-range-thumb {\n  width: 30px;\n  height: 30px;\n  background: #477af6;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.valueText {\n  text-align: center;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.user {\n  display: flex;\n  margin-top: 0.5rem;\n  \n  /* flex-direction: column-reverse;\n  justify-content: space-between; */\n  align-items: center;\n  @media (max-width:400px) {\n    flex-direction: column;\n    \n  }\n}\n\n.one,\n.two,\n.three {\n  border: 1px solid gray;\n  margin: 1rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  cursor: pointer; /* Add cursor pointer */\n}\n\n.one.selected,\n.two.selected,\n.three.selected {\n  border: 2px solid #3498db; /* Dark border for selected */\n  background-color: #f0f0f0; /* Optional: Add background color for selected */\n}\n\n\nl {\n  list-style-type: none;\n  padding: 0;\n}\n\nli {\n  margin-bottom: 8px;\n}\n\nspan {\n  margin-left: 4px;\n}\n\n/* button {\n  background-color: #3498db;\n  color: #ffffff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 16px;\n} */\n\n.info-popup {\n  position: absolute;\n  right: 100%; \n  top: 0;\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 10px;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.info-popup:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  margin-top: -5px; \n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent transparent white;\n}\n\n.class {\n  margin: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PricingComponent_main__ZvYzs`,
	"first": `PricingComponent_first__5atGc`,
	"verticalline": `PricingComponent_verticalline__I9GLG`,
	"second": `PricingComponent_second__YoukZ`,
	"third": `PricingComponent_third__dP8Fu`,
	"user": `PricingComponent_user__k7Hnp`,
	"inputContainer": `PricingComponent_inputContainer__xZnMQ`,
	"inputRange": `PricingComponent_inputRange__SH+R+`,
	"valueText": `PricingComponent_valueText__PHSff`,
	"one": `PricingComponent_one__BmtVX`,
	"two": `PricingComponent_two__6nwz7`,
	"three": `PricingComponent_three__VacYM`,
	"selected": `PricingComponent_selected__A5wGu`,
	"info-popup": `PricingComponent_info-popup__mTaF2`,
	"class": `PricingComponent_class__PBxqE`
};
export default ___CSS_LOADER_EXPORT___;
